'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const MagnifyingGlass = _ref => {
  let {
    fill,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, rest), /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.6273 16L16 14.6273L11.4531 10.0804H10.7239L10.4665 9.82306C11.4102 8.73637 11.882 7.44951 11.882 5.96247C11.882 4.30384 11.3101 2.89544 10.1662 1.73727C9.02234 0.579088 7.62109 0 5.96247 0C4.30384 0 2.89544 0.579088 1.73727 1.73727C0.579088 2.89544 0 4.30384 0 5.96247C0 7.62109 0.579088 9.02234 1.73727 10.1662C2.89544 11.3101 4.30384 11.882 5.96247 11.882C7.44951 11.882 8.73637 11.4102 9.82306 10.4665L10.0804 10.7239V11.4531L14.6273 16ZM5.96247 10.0804C4.81859 10.0804 3.84629 9.68007 3.04558 8.87936C2.24486 8.07864 1.8445 7.10635 1.8445 5.96247C1.8445 4.81859 2.24486 3.84629 3.04558 3.04558C3.84629 2.24486 4.81859 1.8445 5.96247 1.8445C7.10635 1.8445 8.07864 2.24486 8.87936 3.04558C9.68007 3.84629 10.0804 4.81859 10.0804 5.96247C10.0804 7.10635 9.68007 8.07864 8.87936 8.87936C8.07864 9.68007 7.10635 10.0804 5.96247 10.0804Z",
    fill: fill ?? 'currentColor'
  }));
};
/* eslint-enable react/prop-types */

exports["default"] = MagnifyingGlass;
